<template>
  <q-icon
    name="icon-question-circle"
    class="tooltip-question-icon"
  >
    <q-tooltip
      class="tooltip-background"
      self="center left"
      :offset="[10, 10]"
    >
      <div
        data-testid="tooltip-text"
        class="tooltip-default ibf-h8 tooltip tooltip-data"
      >
        {{ tipText }}
      </div>
    </q-tooltip>
  </q-icon>
</template>

<script>
export default {
  name: 'IbTooltip',
  props: {
    tipText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-data {
  width: 190px;
  min-height: 100px;
}
.tooltip-question-icon {
  margin-left: 3px;
  margin-top: -2px;
}
</style>
